{
  "data_records_grid": {
    "columns": "Colonnes"
  },
  "custom_objects": {
    "import_error": "Erreur d'importation",
    "export_all": "Tout exporter"
  },
  "grid": {
    "workspace_columns": "Colonnes de l'espace de travail"
  },
  "schema": {
    "manage_columns": "Gérer les colonnes",
    "field_name": "Nom du champ",
    "type": "Type",
    "options": "Options",
    "action": "Action"
  },
  "fields": {
    "no_custom_fields_to_edit": "Aucun champ personnalisé à modifier",
    "edit_custom_fields": "Modifier les champs personnalisés",
    "field_name": "Nom du champ",
    "options": "Options",
    "update_list_name": "Mettre à jour le nom de la liste",
    "placeholder_default": "Nom",
    "type_options_placeholder": "Saisir les options",
    "type_or_paste_options": "Saisir ou coller les options avec délimiteur virgule...",
    "validation": {
      "enter_name": "veuillez saisir un nom",
      "enter_value": "veuillez saisir une valeur"
    }
  },
  "status": {
    "loading_data": "Chargement des données",
    "updated": "Mis à jour !"
  },
  "accessibility": {
    "drag_option": "faire glisser l'option",
    "remove_option": "supprimer l'option"
  }
}
